
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Vue } from "vue-property-decorator";
import NR, { CV, Ats } from "@/lib//model/NRXQ/nr";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import AtsTable from "@/views/nr/components/ats-candidate-table.vue";
import AtsCv from "@/views/nr/components/ats-cv.vue";
import Model from "@/lib/model/model";
import Url from "@/lib/common/url";

@Component({
  components: { AtsCv }
})
export default class CustomList extends Vue {
  cvId = 0;
  showCV = false;

  created() {
    this.cvId = parseInt(Url.query("cvId"));
    this.showCV = true;
  }
  mounted() {
    //
  }

  closeCv() {
    this.showCV = false;
  }
}
